// Modules
import { ROUTES_PATH } from 'constants/routesPath'
import React from 'react'

// Components
import { RedirectBuilder } from '../../../builders'

export const SNHomeRedirect: React.VFC = () => <RedirectBuilder redirectPath={ROUTES_PATH.SIGN_UP_PERSONAL_DATA} />
